import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const WfIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="#000091" d="M0 0h213.3v480H0z" />
    <path fill="#e1000f" d="M426.7 0H640v480H426.7z" />
  </ChakraIcon>
);
